export class RangeLoop {
  constructor(config) {
    this.originConfig = JSON.parse(JSON.stringify(config))
    this.range = config.range || [0, 100]
    this.start = this.range[0]
    this.end = this.range[1]
    this.value = config.value || 0
    this.isPlaying = false
    this.animationId = null
    this.factor = 0.9955 // 阻尼系数
    this.watchValue = config.watchValue
    this.endCallback = config.endCallback
    this.speed = config.speed || 1
    this.endLength = undefined
    this.loop = 2 // 一次循环的圈
    this.errorScope = config?.errorScope || 0.1
    this.targetValue = undefined
    this.endScope = config?.endScope || 200 // 结束范围 在这个范围内会减速 会拿当前值与目标值比较 step的长度
  }

  reset(resetValue = true) {
    if (resetValue) {
      this.value = this.start
    }
    this.speed = this.originConfig?.speed || 1
    this.targetValue = undefined
    this.isPlaying = false
    cancelAnimationFrame(this.animationId)
  }

  play() {
    if (this.isPlaying) return
    this.isPlaying = true
    this.animate()
  }

  animate() {
    const val = this.value + this.speed
    if (val >= this.end) {
      this.value = val - this.end + this.start
    } else {
      this.value = val
    }
    this.animationId = requestAnimationFrame(() => this.animate())
    if (this.watchValue) {
      this.watchValue(this.value)
    }
  }

  stop() {
    this.isPlaying = false
    cancelAnimationFrame(this.animationId)
    return {
      value: this.value,
      target: this.targetValue,
    }
  }

  pick(val) {
    this.targetValue = val
    cancelAnimationFrame(this.animationId)
    this.endLength = this.end - this.value + (this.end - this.start) * this.loop + val
    this.isPlaying = false
    this.decelerate(val)
  }

  decelerate(targetValue) {
    if (this.endLength <= this.endScope) {
      this.speed = this.speed * this.factor
    }
    this.endLength -= this.speed
    const val = this.value + this.speed
    if (val >= this.end) {
      this.value = val - this.end + this.start
    } else {
      this.value = val
    }
    if (this.endLength <= 0 && Math.abs((this.value - targetValue)) < this.errorScope) {
      cancelAnimationFrame(this.animationId)
      if (this.watchValue) {
        this.watchValue(targetValue)
      }
      if (this.endCallback) {
        this.endCallback(targetValue)
      }
      return
    }

    this.animationId = requestAnimationFrame(() => this.decelerate(targetValue))

    if (this.watchValue) {
      this.watchValue(this.value)
    }
  }
}
